import { Text } from "@chakra-ui/react";
import { Section } from "components/section";
import React from "react";
import { Container } from "ui/container";
import { AnimationSection } from "./animation-section";
import { StepOneAnimation, StepOneMobileSvg } from "./step-1";
import { StepTwoAnimation, StepTwoMobileSvg } from "./step-2";
import { StepThreeAnimation, StepThreeMobileSvg } from "./step-3";

export function AidSteps() {
  return (
    <Section fullWidth noContainerPx bg="new.violet.950" themeBgColor="new.violet.950" theme="dark" py={0}>
      <Container mb={{ base: "small", md: "big", lg: "huge" }}>
        <Text
          as="h2"
          textStyle={{ base: "headline1", sm: "display3", md: "display2", lg: "display1", xl: "poster4" }}
          color="brand.text.dark"
          maxW={{ base: "3xl", lg: "4xl", xl: "5xl" }}
        >
          You can launch AI Decisioning in just 3 steps
        </Text>
      </Container>

      <AnimationSection
        chip="Step 1"
        title="Define goals for your AI agents"
        description="Set your target audience and the business outcomes you want to achieve. Your AI agents will then continuously optimize decisions to meet those goals."
        animation={<StepOneAnimation />}
        animationProps={{ w: "82%", left: "18%" }}
        mobile={<StepOneMobileSvg />}
      />
      <AnimationSection
        chip="Step 2"
        title="Provide content and set guardrails"
        description="Stay in full control by authorizing what actions you want the AI agent to take (or not). You define what’s allowed and what content to use so AI optimizes within your brand’s strategy."
        animation={<StepTwoAnimation />}
        animationProps={{ w: "54%", left: "46%" }}
        mobile={<StepTwoMobileSvg />}
      />
      <AnimationSection
        chip="Step 3"
        title="AI agents optimize, learn, and adapt with every interaction"
        description="AI Decisioning uses reinforcement learning to determine the best message, offer, channel, creative, timing, and frequency for each customer on a 1:1 basis. AI agents continuously experiment, learn, and find the best path to conversion for each individual."
        animation={<StepThreeAnimation />}
        animationProps={{ w: "82%", left: "18%" }}
        mobile={<StepThreeMobileSvg />}
      />
    </Section>
  );
}
